import { Colors, Services, getShortUrl } from '@sigma-frontend-libs/commons'

import { buttonModes, icons } from '@/utils'

import button from '@/components/button'
import flag from '@/components/flag'
import sticker from '@/components/sticker'
import date from '@/components/templates/service/item/date'

function renderShortUrl(h) {
  return h(
    sticker,
    {
      props: {
        value: getShortUrl(this.value),
        label: this.getTranslate(`${Services['url-shortener-tracking']}.labels.shortUrl`),
        icon: icons.link,
        color: Colors.grey,
        copy: true,
        to: {
          name: `${Services['url-shortener']}.single`,
          params: { id: this.value.shortUrlId }
        }
      }
    }
  )
}
function renderDomain(h) {
  if (this.viewport.size.width > 600) {
    return h(
      sticker,
      {
        props: {
          value: this.value.domain,
          label: this.getTranslate(`${Services['url-shortener-tracking']}.labels.domain`),
          icon: icons.domain,
          color: Colors.grey,
          copy: true
        }
      }
    )
  }
}
function renderFlag(h) {
  return h(
    flag,
    {
      props: {
        value: this.value.countryCode,
        squircle: true
      }
    }
  )
}
function renderClientIp(h) {
  if (this.viewport.size.width > 480) {
    return h(
      sticker,
      {
        props: {
          value: this.value.clientIp,
          label: this.getTranslate(`${Services['url-shortener-tracking']}.labels.clientIp`),
          color: Colors.grey,
          copy: true
        },
        scopedSlots: {
          icon: () => {
            return renderFlag.call(this, h)
          }
        }
      }
    )
  }
}
function renderInfo(h) {
  return h(
    'div',
    {
      class: `${Services['url-shortener-tracking']}-item__info`
    },
    [
      renderShortUrl.call(this, h),
      renderDomain.call(this, h),
      renderClientIp.call(this, h)
    ]
  )
}

function renderAction(h) {
  return h(
    button,
    {
      class: 'hover-child',
      props: {
        mode: buttonModes.flat,
        icon: icons.edit
      },
      on: {
        click: this.editCallback
      }
    }
  )
}

function renderCreatedAt(h) {
  return h(
    date,
    {
      props: {
        value: this.value
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        ['service-template-item']: true,
        ['hover-parent hover-parent--opacity']: this.viewport.breakpoint.mdUp,
        [`${Services['url-shortener-tracking']}-item`]: true
      }
    },
    [
      renderInfo.call(this, h),
      renderAction.call(this, h),
      renderCreatedAt.call(this, h)
    ]
  )
}
